import {
  ArrayField,
  BooleanField,
  Datagrid,
  EditButton,
  NumberField,
  Show,
  ShowButton,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DNSZone } from "../types";

const Title = () => {
  const record = useRecordContext<DNSZone>();
  return (
    <span>
      DNS Zone <strong>{record?.name}</strong>
    </span>
  );
};

const ShowActions = () => {
  const record = useRecordContext<DNSZone>();
  return (
    <TopToolbar>
      {record && (
        <ShowButton
          resource="Domain"
          record={{
            id: record.id.toString().split(":")[0],
          }}
          label="Domain"
          icon={<ArrowBackIcon />}
        />
      )}
      <EditButton />
    </TopToolbar>
  );
};

export const DNSZoneShow = () => (
  <Show title={<Title />} actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="serial" />
      <ArrayField source="records">
        <Datagrid bulkActionButtons={false}>
          <TextField source="name" />
          <TextField source="type" />
          <TextField source="content" />
          <NumberField source="ttl" label="TTL" />
          <BooleanField source="disabled" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);

export default DNSZoneShow;
